import { Container, createStyles, Group, SimpleGrid, Text, Title, useMantineTheme } from '@mantine/core';
import { useEffect, useState } from 'react';
import CategoryNavbar from '../../components/category-navbar';
import ProductCard, { ProductCardProp } from '../../components/product-card';
import ImageStorageService from '../../services/ImageStorageService';
import { TranslationService } from '../../services/TranslationService';
import { TranslateField, GetTranslated } from '../../types/translate-field';
import API from '../../apis/api';
import { TranslateCategory } from '../../apis/response/GetCategoryResponse';
import NavBar, { NavBarItem } from '../../components/navbar';
import DefaultContainer from '../../components/container';
import { CurrentLocale } from '../../App';
import { useParams } from 'react-router-dom';
import { GetPortalResponse, ToPortalLink } from '../../apis/response/GetPortalResponse';
import { GetNavbarCategoriesReponse, TransformToCategoryMenu } from '../../apis/response/GetNavbarCategoriesResponse';
import { SharedProps } from '../../types/shared-props';
import { ChineseTitleFormat } from '../../services/SpecialFormatService';

const useStyles = createStyles((theme) => ({
    home: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },

    container: {
        width: 300,
        height: 300,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        alignSelf: 'center',
        zIndex: 1,
        position: 'relative',
        backgroundColor: theme.colors.offWhite[0],
        opacity: 50,
        padding: 30,
        margin: 0,
    },

    hero: {
        position: 'relative',
        //   backgroundImage:
        //     'url(https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: 450,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: '10%',

        [theme.fn.smallerThan('sm')]: {
            padding: '15px',
            justifyContent: 'center',
        },
    },

    title: {
        color: theme.colors.hkc[1],
        fontSize: theme.other.layout.title.fontSize,
        fontFamily: theme.other.titleFont,
        fontWeight: theme.other.layout.title.fontWeight,
        lineHeight: theme.other.layout.title.lineHeight,
        textAlign: 'left',
    },
    description: {
        color: theme.colors.hkc[2],
        textAlign: 'left',
        fontSize: 20,
    },
    slash: {
        height: theme.other.layout.slashHeight,
        backgroundColor: theme.colors.hkc[0],
        width: '80%',
        marginTop: 25,
    },

    dividerContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        zIndex: 4
    },
    dividerBox: {
        flex: 1,
        flexGrow: 3,
        backgroundColor: theme.colors.hkc[1],
        height: theme.other.layout.slashHeight
    },
    dividerText: {
        padding: '25px 40px',
        color: theme.colors.hkc[0],
        fontWeight: 650,
        fontSize: theme.other.layout.sectionTitleFontSize,
    },
    card: {
        width: '100%'
    },
    grid: {
        paddingBottom: 20,
        marginBottom: 15
    }
}));

interface DepartmentPageProps {
    imgBinaryList?: ProductCardProp[];
    name?: TranslateField;
    desc?: TranslateField;
    cover?: string;
    catInfo?: TranslateField;
    cat?: string
}

const Department = () => {
    const { classes } = useStyles()
    const init: DepartmentPageProps & SharedProps = {}
    const [props, setProps] = useState(init)
    // const data = props.categories
    const { deptId } = useParams()

    const fetchData = async () => {

        const imageService = new ImageStorageService()
        const imgBinaryList = await imageService.GetSubCatList(`${deptId}`)

        const cat = (await API.Category.GetCatByDept(`${deptId}`)).obj.category_id
        const cover = await imageService.GetRandomCatCover(`${cat}`)
        const info = (await API.Category.GetCat(cat)).obj
        const catInfo = TranslateCategory(info.items[0])

        const translate = new TranslationService()
        const name = await translate.TranslateDepartmentName(`${deptId}`)
        const desc = await translate.TranslateDepartmentDesc(`${deptId}`)

        
        const c: GetNavbarCategoriesReponse = (await API.Category.GetNavbarCategories()).obj
        const categories = TransformToCategoryMenu(c.items)
        const usefulRes: GetPortalResponse = (await API.Info.GetUsefulLinks()).obj
        const useful = usefulRes.items.map(x => ToPortalLink(x))

        const navTree: NavBarItem[] = [
            { title: catInfo, slug: `/Category/${cat}` },
            { title: name, slug: `/Department/${deptId}` },
        ]


        imgBinaryList.sort((x,y)=>{
            console.log(x.display_order)
            if (x.display_order > y.display_order) {
              return 1;
            }
            if (x.display_order < y.display_order) {
                return -1;
            }
            return 0;
          })

        const newProps = {
            imgBinaryList, name, desc, cover, catInfo, cat, categories, useful, navTree
        }     
        
        setProps(newProps)
    }
    useEffect(() => {
        fetchData()
    }, [])

    const subCat = props.imgBinaryList ?? []
    return (
        <DefaultContainer>
        {
            props.categories && props.useful ?
                <CategoryNavbar data={props.categories} useful={props.useful} />
                : <></>
        }
        <NavBar navTree={props.navTree ?? []} />
            <div className={classes.hero} style={{ backgroundImage: `url('${props.cover}')` }}>
                {/* <Overlay
                        gradient="linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .50) 90%)"
                        opacity={1}
                        zIndex={0}
                    /> */}
                <Container className={classes.container}>
                    <Group style={{width: '100%'}}>
                        <Title className={classes.title} dangerouslySetInnerHTML={{__html: ChineseTitleFormat(GetTranslated(props.catInfo, CurrentLocale) )}}>
                        </Title>
                        <div className={classes.slash}></div>
                    </Group>
                </Container>
            </div>
            <div className={classes.dividerContainer}>
                <div className={classes.dividerBox}></div>
                <Text className={classes.dividerText}>{ props.name ? GetTranslated(props.name, CurrentLocale) : ''}</Text>
                <div className={classes.dividerBox}></div>
            </div>
            {/* <Carousel photos={subCat} showIndexor /> */}
            <SimpleGrid className={classes.grid} cols={4} spacing={'sm'} breakpoints={[{ maxWidth: 'lg', cols: 3 }, { maxWidth: 'md', cols: 2 }, { maxWidth: 'sm', cols: 1 }]}>
                {
                    subCat.map((x: ProductCardProp) => {
                        return <ProductCard key={x.slug} prop={x} className={classes.card} />
                    })
                }
            </SimpleGrid>
        </DefaultContainer>
    )
}
export default Department

